var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 117C27.1 117 1 90.9 1 59C1 27.1 27.1 1 59 1C90.9 1 117 27.1 117 59C117 90.9 90.9 117 59 117ZM59 9.28571C31.6571 9.28571 9.28571 31.6571 9.28571 59C9.28571 86.3429 31.6571 108.714 59 108.714C86.3429 108.714 108.714 86.3429 108.714 59C108.714 31.6571 86.3429 9.28571 59 9.28571Z",
    fill: "#3AC651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7137 79.7124C49.4708 79.7124 48.228 79.2981 47.3994 78.0552L30.828 57.3409C29.5851 55.6838 29.5851 52.7838 31.6565 51.5409C33.728 50.2981 36.2137 50.2981 37.4565 52.3695L51.128 69.3552L80.9565 35.7981C82.6137 34.1409 85.0994 33.7267 86.7565 35.3838C88.4137 37.0409 88.828 39.5266 87.1708 41.1838L54.028 78.4695C53.1994 79.2981 51.9565 79.7124 50.7137 79.7124Z",
    fill: "#3AC651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDone);
export default __webpack_public_path__ + "static/media/payment_done.7829f6b30e17acf2762a4092578a8f28.svg";
export { ForwardRef as ReactComponent };